import { Button } from "@mantine/core";
import { IconPlus } from "@tabler/icons-react";
import { Link } from "react-router-dom";
import { useLanguage } from "../../../../stores/LanguageStore";

const CreateSignatureButton = () => {
  const lang = useLanguage((s) => s.language);
  return (
    <Button
      component={Link}
      to={`/models/email-signatures/create`}
      leftSection={<IconPlus size={18} />}
      radius={"sm"}
      color="primary"
    >
      {lang.emails_signature.create.button_tooltip}
    </Button>
  );
};

export default CreateSignatureButton;
